module.exports = __webpack_public_path__ + "static/human-ethos-retention-bcdb5b3b355cbc7a643630a1d6328ae9.pdf";